import React from 'react';

type StarProps = {
  className?: string;
  ariaLabel?: string;
  ariaHidden?: boolean;
  size?: number;
};

const Star: React.FC<StarProps> = ({ ariaLabel, ariaHidden, className = '', size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 37"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label={ariaLabel}
    aria-hidden={ariaHidden}
    role="img"
    data-testid="star-icon"
  >
    <path
      d="M18.9612 1.99741C19.3455 1.07345 20.6544 1.07345 21.0387 1.99741L25.2906 12.2203C25.4527 12.6098 25.819 12.876 26.2395 12.9097L37.276 13.7945C38.2735 13.8744 38.6779 15.1193 37.9179 15.7703L29.5093 22.9732C29.1889 23.2476 29.049 23.6782 29.1469 24.0886L31.7159 34.8583C31.948 35.8317 30.8891 36.6011 30.0351 36.0794L20.5864 30.3082C20.2264 30.0883 19.7736 30.0883 19.4135 30.3082L9.96477 36.0794C9.11078 36.6011 8.05187 35.8317 8.28406 34.8583L10.853 24.0886C10.9509 23.6782 10.811 23.2476 10.4906 22.9732L2.08197 15.7703C1.32199 15.1193 1.72646 13.8744 2.72395 13.7945L13.7604 12.9097C14.181 12.876 14.5473 12.6098 14.7093 12.2203L18.9612 1.99741Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Star;
